/*
 * @Author: your name
 * @Date: 2020-03-21 15:47:03
 * @LastEditTime: 2026-06-30 11:05:09
 * @LastEditors: DY
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud_Mobile\src\services\api.js
 */
import axios from 'axios';
import '@/store/index';
import { Toast, Dialog } from 'vant';
import Vue from 'vue';
Vue.prototype.$axios = axios;
let isRefreshToken = false;
axios.interceptors.request.use(config => {
    let token = null;
    if (config.url.indexOf('SwitchTenant') < 0) {
        token = window.localStorage.getItem('token');
    } else {
        token = window.localStorage.getItem('refreshToken');
    }
    // 判断是否为 FormData 上传，FormData 应由浏览器自动设置 Content-Type（含 boundary）
    const isFormData = config.data instanceof FormData;
    // 判断是否为跨域请求（绝对 URL），文件服务等跨域请求不应带 Authorization 和 withCredentials，
    // 否则会触发 CORS 预检导致 Network Error
    const isCrossOrigin = /^https?:\/\//.test(config.url || '');

    // 保留原有 headers，不直接覆盖，避免丢失 axios/浏览器自动设置的头部
    config.headers = {
        ...config.headers,
        Accept: 'application/json',
    };
    // 仅对同源请求添加 Authorization 和 withCredentials
    if (!isCrossOrigin) {
        config.headers.Authorization = token;
        config.withCredentials = true;
    }
    // 非 FormData 且非跨域时才设置 Content-Type 为 application/json
    if (!isFormData && !isCrossOrigin && !config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }

    return config;
});

axios.interceptors.response.use(
    res => {
        const headers = res.headers;
        if (['application/octet-stream'].indexOf(headers['content-type']) > -1 || res.request.responseType === 'arraybuffer') {
            return res;
        }
        const data = res.data;
        if (data) {
            if (data.result === 1 || data.ErrorCode?.Code === '0') {
                return data.DataContext;
            }
            if (data.ErrorCode && data.ErrorCode.Code !== '0') {
                // const msg = data.ErrorCode.Message;
                // Toast(msg);
                throw data;
            }
            if (res.status === 200 && !data.DataContext) {
                return data;
            }
        }
        throw data;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    if (!isRefreshToken) {
                        isRefreshToken = true;
                        sessionStorage.setItem('token', window.sessionStorage.getItem('refreshToken'));
                        const refreshToken = window.sessionStorage.getItem('refreshToken');
                        return axios.post('/interfaceApi/login/refresh_token', {
                            refresh_token: refreshToken,
                        }, {
                            headers: {
                                ContentType: 'application/x-www-form-urlencoded',
                            },
                        }).then(res => {
                            sessionStorage.setItem('token', res.AccessToken);
                            sessionStorage.setItem('refreshToken', res.RefreshToken);
                            return axios.request(error.config);
                        }).catch(() => {
                            Dialog({ message: '登录异常，请重新登录！' });
                            window.$globalHub.$callMobile('JYTeamsNative', 'jyLogout');
                        });
                    }
                    Dialog({ message: '登录状态已过期，请重新登录！' });
                    setTimeout(() => {
                        window.$globalHub.$callMobile('JYTeamsNative', 'jyLogout');
                    }, 2000);
            }
        }
        return Promise.reject(error.response?.data || error); // 返回接口返回的错误信息
    }
);
// eslint-disable-next-line max-params
function send(url, method, body, options, defEx) {
    const opts = { ...options };
    let token = null;
    if (url.indexOf('SwitchTenant') < 0) {
        token = window.sessionStorage.getItem('token');
    } else {
        token = window.sessionStorage.getItem('refreshToken');
    }
    opts.headers = {
        Accept: 'application/json',
        Authorization: token,
        'Conteent-Type': 'application/json',
        ...opts.headers,
    };
    return axios({ method, url, data: body, ...opts })
        .then(res => {
            return res;
        }).catch(error => {
            const msg = error.ErrorCode.Message;
            // 接口异常处理
            if (defEx) {
                // 通用异常处理
                Toast(msg);
            } else {
                // 返回前台处理
                return Promise.reject(error);
            }
        });
}
Vue.prototype.$axios.$get = (url, { options = null, defEx = false } = {}) => {
    return send(url, 'get', null, options, defEx);
};
Vue.prototype.$axios.$post = (url, body, { options = null, defEx = false } = {}) => {
    return send(url, 'post', body, options, defEx);
};
Vue.prototype.$axios.$put = (url, body, { options = null, defEx = false } = {}) => {
    return send(url, 'put', body, options, defEx);
};
